export default defineNuxtPlugin(async (nuxtApp) => {
    if (import.meta.client) {
        const { Vue3Lottie } = await import('vue3-lottie')
        nuxtApp.vueApp.component('Vue3Lottie', Vue3Lottie)
    }
})
